import { includes } from 'lodash';

const whiteList = Object.freeze(['fonts.googleapis.com']);

export const validateFontLink = link => {
  if (typeof link !== 'string') {
    return false;
  }

  try {
    const url = new URL(link);
    const isWhiteListed = includes(whiteList, url.host);
    const isSecure = url.protocol === 'https:';
    if (isSecure && isWhiteListed) {
      return true;
    }
    return false;
  } catch (ex) {
    return false;
  }
};
